/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/* Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved. */

import { ExclamationTriangleIcon } from '@/shared/ui/radix-icons';
import { DataStateError, Text } from '@/shared/ui';

interface SettingsErrorStateProps {
  /** Invoked when the user clicks the retry control. */
  onRetry: () => void;
}

/**
 * Error fallback for the agency settings surface, shown when the agency record
 * fails to load. Delegates to the shared {@link DataStateError} visual while
 * preserving the settings-specific min-height and the `settings-error` test id.
 *
 * @param props The retry handler invoked when the user retries.
 * @returns The settings error element, tagged for tests.
 */
export function SettingsErrorState({ onRetry }: SettingsErrorStateProps) {
  return (
    <div
      data-testid="settings-error"
      className="flex min-h-0 flex-1 flex-col p-(--space-5)"
      style={{ minHeight: 480, fontFamily: 'var(--font-family)' }}
    >
      <DataStateError
        icon={
          <Text component="span" className="flex text-(--status-error)">
            <ExclamationTriangleIcon width={28} height={28} />
          </Text>
        }
        message="Não foi possível carregar as configurações."
        onRetry={onRetry}
        data-testid="settings-error-visual"
      />
    </div>
  );
}
